"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasPersistDirective = exports.extractPersistDirectivePaths = exports.addPersistFieldToDocument = void 0;

var _graphql = require("graphql");

var _apolloUtilities = require("apollo-utilities");

var PERSIST_FIELD = {
  kind: 'Field',
  name: {
    kind: 'Name',
    value: '__persist'
  }
};

var addPersistFieldToSelectionSet = function addPersistFieldToSelectionSet(selectionSet) {
  var isRoot = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (selectionSet.selections) {
    if (!isRoot) {
      var alreadyHasThisField = selectionSet.selections.some(function (selection) {
        return selection.kind === 'Field' && selection.name.value === '__typename';
      });

      if (!alreadyHasThisField) {
        selectionSet.selections.push(PERSIST_FIELD);
      }
    }

    selectionSet.selections.forEach(function (selection) {
      // Must not add __typename if we're inside an introspection query
      if (selection.kind === 'Field') {
        if (selection.name.value.lastIndexOf('__', 0) !== 0 && selection.selectionSet) {
          addPersistFieldToSelectionSet(selection.selectionSet);
        }
      } else if (selection.kind === 'InlineFragment') {
        if (selection.selectionSet) {
          addPersistFieldToSelectionSet(selection.selectionSet);
        }
      }
    });
  }
};

var addPersistFieldToDocument = function addPersistFieldToDocument(doc) {
  (0, _apolloUtilities.checkDocument)(doc);
  var docClone = (0, _apolloUtilities.cloneDeep)(doc);
  docClone.definitions.forEach(function (definition) {
    var isRoot = definition.kind === 'OperationDefinition';
    addPersistFieldToSelectionSet(definition.selectionSet, isRoot);
  });
  return docClone;
};

exports.addPersistFieldToDocument = addPersistFieldToDocument;

var extractPersistDirectivePaths = function extractPersistDirectivePaths(originalQuery) {
  var directive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'persist';
  var paths = [];
  var fragmentPaths = {};
  var fragmentPersistPaths = {};
  var query = (0, _graphql.visit)(originalQuery, {
    FragmentSpread: function FragmentSpread(_ref, key, parent, path, ancestors) {
      var name = _ref.name.value;
      var root = ancestors.find(function (_ref2) {
        var kind = _ref2.kind;
        return kind === 'OperationDefinition' || kind === 'FragmentDefinition';
      });
      var rootKey = root.kind === 'FragmentDefinition' ? root.name.value : '$ROOT';
      var fieldPath = ancestors.filter(function (_ref3) {
        var kind = _ref3.kind;
        return kind === 'Field';
      }).map(function (_ref4) {
        var name = _ref4.name.value;
        return name;
      });
      fragmentPaths[name] = [rootKey].concat(fieldPath);
    },
    Directive: function Directive(_ref5, key, parent, path, ancestors) {
      var name = _ref5.name.value;

      if (name === directive) {
        var fieldPath = ancestors.filter(function (_ref6) {
          var kind = _ref6.kind;
          return kind === 'Field';
        }).map(function (_ref7) {
          var name = _ref7.name.value;
          return name;
        });
        var fragmentDefinition = ancestors.find(function (_ref8) {
          var kind = _ref8.kind;
          return kind === 'FragmentDefinition';
        }); // If we are inside a fragment, we must save the reference.

        if (fragmentDefinition) {
          fragmentPersistPaths[fragmentDefinition.name.value] = fieldPath;
        } else if (fieldPath.length) {
          paths.push(fieldPath);
        }

        return null;
      }
    }
  }); // In case there are any FragmentDefinition items, we need to combine paths.

  if (Object.keys(fragmentPersistPaths).length) {
    (0, _graphql.visit)(originalQuery, {
      FragmentSpread: function FragmentSpread(_ref9, key, parent, path, ancestors) {
        var name = _ref9.name.value;

        if (fragmentPersistPaths[name]) {
          var fieldPath = ancestors.filter(function (_ref10) {
            var kind = _ref10.kind;
            return kind === 'Field';
          }).map(function (_ref11) {
            var name = _ref11.name.value;
            return name;
          });
          fieldPath = fieldPath.concat(fragmentPersistPaths[name]);
          var fragment = name;
          var _parent = fragmentPaths[fragment][0];

          while (_parent && _parent !== '$ROOT' && fragmentPaths[_parent]) {
            fieldPath = fragmentPaths[_parent].slice(1).concat(fieldPath);
            _parent = fragmentPaths[_parent][0];
          }

          paths.push(fieldPath);
        }
      }
    });
  }

  return {
    query: query,
    paths: paths
  };
};

exports.extractPersistDirectivePaths = extractPersistDirectivePaths;

var hasPersistDirective = function hasPersistDirective(doc) {
  var hasDirective = false;
  (0, _graphql.visit)(doc, {
    Directive: function Directive(_ref12) {
      var name = _ref12.name.value;

      if (name === 'persist') {
        hasDirective = true;
        return _graphql.BREAK;
      }
    }
  });
  return hasDirective;
};

exports.hasPersistDirective = hasPersistDirective;